
import { Form } from 'antd';
import { last } from 'lodash';
import moment, { Moment } from 'moment';
import React from 'react';
import styled from 'styled-components';
import RequestInput from '../RequestInput';
import { ServiceBottomSheetRef } from '../ServiceBottomSheet';
import { StaffBottomSheetRef } from '../StaffBottomSheet';
import SwipeToDeleteItem from '../SwipeToDeleteItem';
import { IFormValueServiceItem, IGroupCustomerItem } from '../types';
import ic_add from './ic_add.png';
import ic_edit_blue from './ic_edit_blue.png';
import CustomerServiceItem from './ServiceItem';
type Props = {
  index?: number;
  name?: any;
  value?: IGroupCustomerItem;
  serviceBs: React.RefObject<ServiceBottomSheetRef>;
  staffBs: React.RefObject<StaffBottomSheetRef>;
  onChange?: (value?: IGroupCustomerItem) => void;
  customerLength?: number;
  editName?: boolean;
  single?: boolean;
};
const CustomerServices = ({ value, name, index: customerIndex = 0, serviceBs, staffBs, onChange, editName = true, single = false }: Props) => {
  const form = Form.useFormInstance();
  const handleAddServices = () => serviceBs.current?.open((newSers) => {
    const services = [...value?.services || []];
    let startTime = last(services)?.endTime;
    if (customerIndex === 0 && !value?.services?.length) {
      const staff = form.getFieldValue('staff');
      newSers.map(o => {
        const endTime = moment(startTime, 'hh:mm A').add(o.duration, 'minutes').format('hh:mm A');
        services.push({
          ...o, startTime: startTime || '', endTime,
          staffId: staff?.id || '',
          staffAvatar: staff?.urlImage || '',
          staffName: staff?.nickName || '',
        });
        startTime = endTime;
      });
    } else {
      newSers.map(o => {
        const endTime = moment(startTime, 'hh:mm A').add(o.duration, 'minutes').format('hh:mm A');
        services.push({ ...o, startTime: startTime || '', endTime });
        startTime = endTime;
      });
    }
    onChange?.({
      name: value?.name || '',
      uuid: value?.uuid || '',
      requestStaff: value?.requestStaff || false,
      services
    });
  });

  const handleChangeStaff = (o?: IFormValueServiceItem) => {
    if (!o) return;
    const date: Moment = form.getFieldValue('date');
    staffBs.current?.open([o.staffId], {
      serviceIds: [o.id],
      startTime: `${date.format('MM-DD-YYYY')} ${moment(o.startTime, 'hh:mm A').format('HH:mm')}`,
      endTime: `${date.format('MM-DD-YYYY')} ${moment(o.endTime, 'hh:mm A').format('HH:mm')}`,
    },
      (staff) => {
        const services = value?.services?.map(c => c.local_uuid === o.local_uuid ? ({
          ...c,
          staffId: staff.id,
          staffName: staff.nickName,
          staffAvatar: staff.urlImage,
        }) : c) || [];
        onChange?.({
          name: value?.name || '',
          uuid: value?.uuid || '',
          requestStaff: value?.requestStaff || false,
          services
        });
      });
  };

  return (
    <Container className={single ? 'single' : ''}>
      {!single && <CustomerNameGroup>
        <div className="customer-name">
          <span>Customer {customerIndex + 1}: {value?.name}</span>
          {!!editName && <img src={ic_edit_blue} alt="ic_edit_blue" style={{ width: '24px', height: '24px' }} />}
        </div>
        <Form.Item noStyle name={[name, 'requestStaff']}>
          <RequestInput label='Request' />
        </Form.Item>
      </CustomerNameGroup>}
      <ServiceListStyled >
        <Form.List name={[name, 'services']}>
          {(fields, { remove }) => {
            return <>
              {
                fields.map((field, index) => {
                  return <SwipeToDeleteItem
                    key={field.key}
                    onDelete={() => remove(index)}
                    className="card"
                  >
                    <Form.Item key={field.key} name={field.name} noStyle>
                      <CustomerServiceItem name={field.name} onChangeStaff={handleChangeStaff} />
                    </Form.Item>
                  </SwipeToDeleteItem>;
                })
              }
              <AddServiceStyled>
                <button type='button' className='btn-add' onClick={handleAddServices}>
                  <img src={ic_add} alt="ic_add" style={{ width: '24px', height: '24px' }} />
                  <span>Add service</span>
                </button>
              </AddServiceStyled>
            </>;
          }}
        </Form.List>
      </ServiceListStyled>
    </Container>
  );
};

export default CustomerServices;

const ServiceListStyled = styled.div`
display: flex;
padding: 8px;
flex-direction: column;
align-items: flex-start;
gap: 8px;
align-self: stretch;
border-radius: 4px;
background: #FFF;
`;

const Container = styled.div`
  display: flex;
  padding: 0 8px 8px 8px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  background: #F6F7FC;

&.single {
  padding: 0;
}
`;

const CustomerNameGroup = styled.div`
  display: flex;
  padding: 4px 0;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  div.customer-name {
    display: flex;
    align-items: center;
    gap: 4px;
    span {
      color: #1D2129;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
`;

const AddServiceStyled = styled.div`
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-radius: 4px;
  background: #FFF;
  button.btn-add {
    border-radius: 4px;
    background: #FFF;
    padding: 8px;
    border: 1px dashed #2463EB;
    display: flex;
    height: 40px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    span {
      color: #2463EB;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
`;